export default __webpack_public_path__ + "static/media/Chicago.21945dd6.webp";